import React from 'react';

const SingleColContainer = ({children, className=''}) => (
  <div className={`container ${className}`}>
    <div className='row'>
      <div className='col'>
        {children}
      </div>
    </div>
  </div>
);

export default SingleColContainer;



// WEBPACK FOOTER //
// ./src/components/singleColContainer/index.js